import { GetBodyCustomerAttachedDocumentsQueryParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerAttachedDocuments/getBodyCustomerAttachedDocumentsQuery.type';
import { getBodyCustomerAttachedDocumentsQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerAttachedDocuments/getBodyCustomerAttachedDocumentsQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBodyCustomerAttachedDocumentsQueryOptions = (
  params: GetBodyCustomerAttachedDocumentsQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['getBodyCustomerAttachedDocumentsQueryOptions', params],
    queryFn: () => getBodyCustomerAttachedDocumentsQueryFunction(params),
    enabled: true,
  });
};
